document.addEventListener("DOMContentLoaded", () => {
  let serverUrl = "https://bilstein.potnvehiclefinder.co.uk";
  let pageUrl = "https://www.bilsteinsuspensionstore.co.uk/pages/search";

  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  function capitalizeWords(str) {
    return str.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  }

  let domProducts = [];

  let manufacturerSelect = document.querySelector("#manufacturer");
  let yearSelect = document.querySelector("#year");
  let modelSelect = document.querySelector("#model");
  let subModelSelect = document.querySelector("#subModel");
  let engineSelect = document.querySelector("#engine");
  let bodySelect = document.querySelector("#body");

  let skuSelect = document.querySelector("#sku");
  let productInfo = document.querySelector("#appProductWrapper");
  let filterResetBtn = document.querySelector(".filterReset");
  let filterQueryData;
  let productDefinedPositions = [];
  let productDefinedRanges = [];
  let filterChips = document.querySelector(".currentFilter");

  let manufacturer = getQueryParam("manufacturer");
  let year = getQueryParam("year");
  let model = getQueryParam("model");
  let subModel = getQueryParam("sub_model");
  let engine = getQueryParam("engine");
  let body = getQueryParam("body");

  function updateURL() {
    const manufacturer = manufacturerSelect.value || "";
    const year = yearSelect.value || "";
    const model = modelSelect.value || "";
    const subModel = subModelSelect.value || "";
    const engine = engineSelect.value || "";
    const body = bodySelect.value || "";

    const url = new URL(window.location.href);

    url.searchParams.set("manufacturer", manufacturer);
    url.searchParams.set("year", year);
    url.searchParams.set("model", model);
    url.searchParams.set("sub_model", subModel);
    url.searchParams.set("engine", engine);
    url.searchParams.set("body", body);

    Array.from(url.searchParams.entries()).forEach(([key, value]) => {
      if (!value) url.searchParams.delete(key);
    });

    window.history.pushState({ path: url.href }, "", url.href);
  }

  function fetchManufacturer() {
    fetch(`${serverUrl}/api/csv-data-manufacturer`)
      .then((response) => response.json())
      .then((csvData) => {
        csvData.sort((a, b) => a.manufacturer.localeCompare(b.manufacturer));
        csvData.forEach((product) => {
          const option = document.createElement("option");
          option.value = product.manufacturer;
          option.textContent = product.manufacturer.toUpperCase();
          manufacturerSelect && manufacturerSelect.appendChild(option);
        });
        if (manufacturer) {
          manufacturerSelect.value = manufacturer;
          fetchYears(manufacturer, () => {
            if (year) {
              yearSelect.value = year;
              fetchModels(manufacturer, year, () => {
                if (model) {
                  modelSelect.value = model;
                  fetchSubModels(manufacturer, year, model, () => {
                    if (subModel) {
                      subModelSelect.value = subModel;
                      fetchEngine(manufacturer, year, model, subModel, () => {
                        if (engine) {
                          engineSelect.value = engine;
                          fetchBody(
                            manufacturer,
                            year,
                            model,
                            subModel,
                            engine,
                            () => {
                              if (body) {
                                bodySelect.value = body;
                              }
                            }
                          );
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      })
      .catch((error) => console.error("Error fetching manufacturer:", error));
  }

  fetchManufacturer();

  // Function to fetch years based on the selected model
  function fetchYears(selectedManufacturer, callback) {
    if (!selectedManufacturer) return;

    fetch(
      `${serverUrl}/api/csv-data-years?manufacturer=${selectedManufacturer}`
    )
      .then((response) => response.json())
      .then((years) => {
        const allYears = years.flatMap((item) => item.year);
        const uniqueYearsSet = new Set(allYears);
        const uniqueYears = Array.from(uniqueYearsSet).sort((a, b) => b - a);
        yearSelect.innerHTML =
          '<option value="" disabled selected>Select Year</option>';
        uniqueYears.forEach((year) => {
          const option = document.createElement("option");
          option.value = year;
          option.textContent = year;
          yearSelect.appendChild(option);
        });
        yearSelect.nextElementSibling.classList.add("hidden");
        if (callback) callback();
      })
      .catch((error) => console.error("Error fetching years:", error));
  }

  // Function to fetch models based on the selected manufacturer
  function fetchModels(selectedManufacturer, selectedYear, callback) {
    if (!selectedYear) return;

    fetch(
      `${serverUrl}/api/csv-data-models?manufacturer=${selectedManufacturer}&year=${selectedYear}`
    )
      .then((response) => response.json())
      .then((models) => {
        models.sort((a, b) => a.localeCompare(b));
        modelSelect.innerHTML =
          '<option value="" disabled selected>Select Model</option>';
        models.forEach((modelOption) => {
          const option = document.createElement("option");
          option.value = modelOption;
          option.textContent = modelOption.toUpperCase();
          modelSelect.appendChild(option);
        });
        modelSelect.nextElementSibling.classList.add("hidden");
        if (callback) callback();
      })
      .catch((error) => console.error("Error fetching models:", error));
  }

  // Function to fetch models based on the selected manufacturer
  function fetchSubModels(
    selectedManufacturer,
    selectedYear,
    selectedModel,
    callback
  ) {
    if (!selectedModel) return;

    fetch(
      `${serverUrl}/api/csv-data-sub-models?manufacturer=${selectedManufacturer}&year=${selectedYear}&model=${selectedModel}`
    )
      .then((response) => response.json())
      .then((subModels) => {
        subModels.sort((a, b) => a.localeCompare(b));
        subModelSelect.innerHTML =
          '<option value="" disabled selected>Select Sub Model</option>';
        subModels.forEach((modelOption) => {
          const option = document.createElement("option");
          option.value = modelOption;
          option.textContent = modelOption.toUpperCase();
          subModelSelect.appendChild(option);
        });
        subModelSelect.nextElementSibling.classList.add("hidden");
        if (callback) callback();
      })
      .catch((error) => console.error("Error fetching sub models:", error));
  }

  // Function to fetch engine types based on the selected year
  function fetchEngine(
    selectedManufacturer,
    selectedYear,
    selectedModel,
    selectedSubModel,
    callback
  ) {
    if (!selectedSubModel) return;

    fetch(
      `${serverUrl}/api/csv-data-engine?manufacturer=${selectedManufacturer}&year=${selectedYear}&model=${selectedModel}&sub_model=${selectedSubModel}`
    )
      .then((response) => response.json())
      .then((engineTypes) => {
        engineSelect.innerHTML =
          '<option value="" disabled selected>Select Engine</option>';
        engineTypes.forEach((engineType) => {
          const option = document.createElement("option");
          option.value = engineType.engine;
          option.textContent = capitalizeWords(engineType.engine);
          engineSelect.appendChild(option);
        });
        engineSelect.nextElementSibling.classList.add("hidden");
        if (callback) callback();
      })
      .catch((error) => console.error("Error fetching engine:", error));
  }

  // Function to fetch body based on the selected engine
  function fetchBody(
    selectedManufacturer,
    selectedYear,
    selectedModel,
    selectedSubModel,
    selectedEngine,
    callback
  ) {
    if (!selectedEngine) return;

    fetch(
      `${serverUrl}/api/csv-data-body?manufacturer=${selectedManufacturer}&year=${selectedYear}&model=${selectedModel}&sub_model=${selectedSubModel}&engine=${selectedEngine}`
    )
      .then((response) => response.json())
      .then((bodies) => {
        bodySelect.innerHTML =
          '<option value="" disabled selected>Select Body</option>';
        bodies.forEach((body) => {
          const option = document.createElement("option");
          option.value = body.body;
          option.textContent = capitalizeWords(body.body);
          bodySelect.appendChild(option);
        });
        bodySelect.nextElementSibling.classList.add("hidden");
        if (callback) callback();
      })
      .catch((error) => console.error("Error fetching bodies:", error));
  }

  // Event listener for changes in the "manufacturer" dropdown
  manufacturerSelect &&
    manufacturerSelect.addEventListener("change", () => {
      if (productInfo) {
        productInfo.innerHTML = "";
      }
      yearSelect.value = "";
      modelSelect.value = "";
      modelSelect.innerHTML =
        '<option value="" disabled selected>Select Model</option>';
      subModelSelect.value = "";
      subModelSelect.innerHTML =
        '<option value="" disabled selected>Select Sub Model</option>';
      engineSelect.value = "";
      engineSelect.innerHTML =
        '<option value="" disabled selected>Select Engine</option>';
      bodySelect.value = "";
      bodySelect.innerHTML =
        '<option value="" disabled selected>Select Body</option>';
      yearSelect.nextElementSibling.classList.remove("hidden");
      fetchYears(manufacturerSelect.value);
      updateURL();
      if (productInfo) {
        productInfo.classList.remove("noProductFound");
      }
    });

  // Event listener for changes in the "Year" dropdown
  yearSelect &&
    yearSelect.addEventListener("change", () => {
      if (yearSelect.value != "") {
        if (productInfo) {
          productInfo.innerHTML = "";
        }
        modelSelect.value = "";
        subModelSelect.value = "";
        engineSelect.value = "";
        bodySelect.value = "";
        subModelSelect.value = "";
        subModelSelect.innerHTML =
          '<option value="" disabled selected>Select Sub Model</option>';
        engineSelect.value = "";
        engineSelect.innerHTML =
          '<option value="" disabled selected>Select Engine</option>';
        bodySelect.value = "";
        bodySelect.innerHTML =
          '<option value="" disabled selected>Select Body</option>';

        modelSelect.nextElementSibling.classList.remove("hidden");
        fetchModels(manufacturerSelect.value, yearSelect.value);
        updateURL();
        if (productInfo) {
          productInfo.classList.remove("noProductFound");
        }
      }
    });

  // Event listener for changes in the "Model" dropdown
  modelSelect &&
    modelSelect.addEventListener("change", () => {
      if (productInfo) {
        productInfo.innerHTML = "";
      }
      subModelSelect.value = "";
      engineSelect.value = "";
      engineSelect.innerHTML =
        '<option value="" disabled selected>Select Engine</option>';
      bodySelect.value = "";
      bodySelect.innerHTML =
        '<option value="" disabled selected>Select Body</option>';

      subModelSelect.nextElementSibling.classList.remove("hidden");
      fetchSubModels(
        manufacturerSelect.value,
        yearSelect.value,
        modelSelect.value
      );
      updateURL();
      if (productInfo) {
        productInfo.classList.remove("noProductFound");
      }
    });

  // Event listener for changes in the "sub Model" dropdown
  subModelSelect &&
    subModelSelect.addEventListener("change", () => {
      if (productInfo) {
        productInfo.innerHTML = "";
      }
      engineSelect.value = "";
      bodySelect.value = "";
      bodySelect.innerHTML =
        '<option value="" disabled selected>Select Body</option>';

      engineSelect.nextElementSibling.classList.remove("hidden");
      fetchEngine(
        manufacturerSelect.value,
        yearSelect.value,
        modelSelect.value,
        subModelSelect.value
      );
      updateURL();
      if (productInfo) {
        productInfo.classList.remove("noProductFound");
      }
    });

  // Event listener for changes in the "engine" dropdown
  engineSelect &&
    engineSelect.addEventListener("change", () => {
      if (productInfo) {
        productInfo.innerHTML = "";
      }
      bodySelect.value = "";
      bodySelect.nextElementSibling.classList.remove("hidden");
      fetchBody(
        manufacturerSelect.value,
        yearSelect.value,
        modelSelect.value,
        subModelSelect.value,
        engineSelect.value
      );
      updateURL();
      if (productInfo) {
        productInfo.classList.remove("noProductFound");
      }
    });

  // Event listener for changes in the "engine" dropdown
  bodySelect &&
    bodySelect.addEventListener("change", () => {
      if (productInfo) {
        productInfo.innerHTML = "";
      }
      updateURL();
      if (productInfo) {
        productInfo.classList.remove("noProductFound");
      }
    });

  // filter reset button
  if (filterResetBtn) {
    filterResetBtn.addEventListener("click", (event) => {
      // Reset select elements
      event.preventDefault();
      manufacturerSelect.innerHTML =
        '<option value="" selected>Select manufacturer</option>';
      yearSelect.innerHTML = '<option value="" selected>Select Year</option>';
      modelSelect.innerHTML = '<option value="" selected>Select Model</option>';
      subModelSelect.innerHTML =
        '<option value="" selected>Select Sub Model</option>';
      engineSelect.innerHTML =
        '<option value="" selected>Select Engine</option>';
      bodySelect.innerHTML = '<option value="" selected>Select Body</option>';
      manufacturer = "";
      model = "";
      subModel = "";
      year = "";
      engine = "";
      body = "";
      if (productInfo) {
        productInfo.innerHTML = "";
        productInfo.classList.remove("noProductFound");
      }
      fetchManufacturer();
      updateURL();
      $(".filterOptionContent").removeClass("open").slideUp();
      $(".filterOptionContent").html("");
      if (filterChips) {
        filterChips.innerHTML = "";
      }
      let filterClass = document.querySelector(".customFilter");
      filterClass.classList.remove("data-in");
      showProducts();
    });
  }

  // widget button
  const form = document.getElementById("ebc-product-search");
  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      const urlParams = new URL(window.location).searchParams;
      const manufacturer = urlParams.get("manufacturer");
      const year = urlParams.get("year");
      const model = urlParams.get("model");
      const sub_model = urlParams.get("sub_model");
      const engine = urlParams.get("engine");
      const body = urlParams.get("body");
      const baseUrl = pageUrl;
      const queryString = `?manufacturer=${encodeURIComponent(
        manufacturer
      )}&year=${encodeURIComponent(year)}&model=${encodeURIComponent(
        model
      )}&sub_model=${encodeURIComponent(sub_model)}&engine=${encodeURIComponent(
        engine
      )}&body=${encodeURIComponent(body)}`;
      window.location.href = baseUrl + queryString;
    });
  }

  // product card html
  function productCard(sku, product, query, productDefinedPositions, productDefinedRanges) {
    let tags = product.tags[0].split(",").map((code) => code.trim());
    let productPosition = productDefinedPositions
      .filter((item) => tags.includes(item))
      .join(", ");
    let productRange = productDefinedRanges
      .filter((item) => tags.includes(item))
      .join(", ");
    let quantityDropdownValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    let variant = product.variants.find((variant) => variant.sku === sku);

    // Conditional Stock Info
    let stockInfoHTML = '';
    if(variant.inventory_management){
      stockInfoHTML = variant.inventory_quantity > 0
        ? `<img style="width:22px;" src="https://cdn.shopify.com/s/files/1/0673/3683/1274/files/check_1_2x_5ccff06c-2027-4340-8ee9-bd795d9091d7.png?v=1730206123">
              <span>${variant.inventory_quantity} In stock</span>`
        : `<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#009CDE"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16.1007 13.359L15.5719 12.8272H15.5719L16.1007 13.359ZM16.5562 12.9062L17.085 13.438H17.085L16.5562 12.9062ZM18.9728 12.5894L18.6146 13.2483L18.9728 12.5894ZM20.8833 13.628L20.5251 14.2869L20.8833 13.628ZM21.4217 16.883L21.9505 17.4148L21.4217 16.883ZM20.0011 18.2954L19.4723 17.7636L20.0011 18.2954ZM18.6763 18.9651L18.7459 19.7119H18.7459L18.6763 18.9651ZM8.81536 14.7266L9.34418 14.1947L8.81536 14.7266ZM4.00289 5.74561L3.2541 5.78816L3.2541 5.78816L4.00289 5.74561ZM10.4775 7.19738L11.0063 7.72922H11.0063L10.4775 7.19738ZM10.6342 4.54348L11.2346 4.09401L10.6342 4.54348ZM9.37326 2.85908L8.77286 3.30855V3.30855L9.37326 2.85908ZM6.26145 2.57483L6.79027 3.10667H6.79027L6.26145 2.57483ZM4.69185 4.13552L4.16303 3.60368H4.16303L4.69185 4.13552ZM12.0631 11.4972L12.5919 10.9654L12.0631 11.4972ZM16.6295 13.8909L17.085 13.438L16.0273 12.3743L15.5719 12.8272L16.6295 13.8909ZM18.6146 13.2483L20.5251 14.2869L21.2415 12.9691L19.331 11.9305L18.6146 13.2483ZM20.8929 16.3511L19.4723 17.7636L20.5299 18.8273L21.9505 17.4148L20.8929 16.3511ZM18.6067 18.2184C17.1568 18.3535 13.4056 18.2331 9.34418 14.1947L8.28654 15.2584C12.7186 19.6653 16.9369 19.8805 18.7459 19.7119L18.6067 18.2184ZM9.34418 14.1947C5.4728 10.3453 4.83151 7.10765 4.75168 5.70305L3.2541 5.78816C3.35456 7.55599 4.14863 11.144 8.28654 15.2584L9.34418 14.1947ZM10.7195 8.01441L11.0063 7.72922L9.9487 6.66555L9.66189 6.95073L10.7195 8.01441ZM11.2346 4.09401L9.97365 2.40961L8.77286 3.30855L10.0338 4.99296L11.2346 4.09401ZM5.73263 2.04299L4.16303 3.60368L5.22067 4.66736L6.79027 3.10667L5.73263 2.04299ZM10.1907 7.48257C9.66189 6.95073 9.66117 6.95144 9.66045 6.95216C9.66021 6.9524 9.65949 6.95313 9.659 6.95362C9.65802 6.95461 9.65702 6.95561 9.65601 6.95664C9.65398 6.95871 9.65188 6.96086 9.64972 6.9631C9.64539 6.96759 9.64081 6.97245 9.63599 6.97769C9.62634 6.98816 9.61575 7.00014 9.60441 7.01367C9.58174 7.04072 9.55605 7.07403 9.52905 7.11388C9.47492 7.19377 9.41594 7.2994 9.36589 7.43224C9.26376 7.70329 9.20901 8.0606 9.27765 8.50305C9.41189 9.36833 10.0078 10.5113 11.5343 12.0291L12.5919 10.9654C11.1634 9.54499 10.8231 8.68059 10.7599 8.27309C10.7298 8.07916 10.761 7.98371 10.7696 7.96111C10.7748 7.94713 10.7773 7.9457 10.7709 7.95525C10.7677 7.95992 10.7624 7.96723 10.7541 7.97708C10.75 7.98201 10.7451 7.98759 10.7394 7.99381C10.7365 7.99692 10.7335 8.00019 10.7301 8.00362C10.7285 8.00534 10.7268 8.00709 10.725 8.00889C10.7241 8.00979 10.7232 8.0107 10.7223 8.01162C10.7219 8.01208 10.7212 8.01278 10.7209 8.01301C10.7202 8.01371 10.7195 8.01441 10.1907 7.48257ZM11.5343 12.0291C13.0613 13.5474 14.2096 14.1383 15.0763 14.2713C15.5192 14.3392 15.8763 14.285 16.1472 14.1841C16.28 14.1346 16.3858 14.0763 16.4658 14.0227C16.5058 13.9959 16.5392 13.9704 16.5663 13.9479C16.5799 13.9367 16.5919 13.9262 16.6024 13.9166C16.6077 13.9118 16.6126 13.9073 16.6171 13.903C16.6194 13.9008 16.6215 13.8987 16.6236 13.8967C16.6246 13.8957 16.6256 13.8947 16.6266 13.8937C16.6271 13.8932 16.6279 13.8925 16.6281 13.8923C16.6288 13.8916 16.6295 13.8909 16.1007 13.359C15.5719 12.8272 15.5726 12.8265 15.5733 12.8258C15.5735 12.8256 15.5742 12.8249 15.5747 12.8244C15.5756 12.8235 15.5765 12.8226 15.5774 12.8217C15.5793 12.82 15.581 12.8183 15.5827 12.8166C15.5862 12.8133 15.5895 12.8103 15.5926 12.8074C15.5988 12.8018 15.6044 12.7969 15.6094 12.7929C15.6192 12.7847 15.6265 12.7795 15.631 12.7764C15.6403 12.7702 15.6384 12.773 15.6236 12.7785C15.5991 12.7876 15.501 12.8189 15.3038 12.7886C14.8905 12.7253 14.02 12.3853 12.5919 10.9654L11.5343 12.0291ZM9.97365 2.40961C8.95434 1.04802 6.94996 0.83257 5.73263 2.04299L6.79027 3.10667C7.32195 2.578 8.26623 2.63181 8.77286 3.30855L9.97365 2.40961ZM4.75168 5.70305C4.73201 5.35694 4.89075 4.9954 5.22067 4.66736L4.16303 3.60368C3.62571 4.13795 3.20329 4.89425 3.2541 5.78816L4.75168 5.70305ZM19.4723 17.7636C19.1975 18.0369 18.9029 18.1908 18.6067 18.2184L18.7459 19.7119C19.4805 19.6434 20.0824 19.2723 20.5299 18.8273L19.4723 17.7636ZM11.0063 7.72922C11.9908 6.7503 12.064 5.2019 11.2346 4.09401L10.0338 4.99295C10.4373 5.53193 10.3773 6.23938 9.9487 6.66555L11.0063 7.72922ZM20.5251 14.2869C21.3429 14.7315 21.4703 15.7769 20.8929 16.3511L21.9505 17.4148C23.2908 16.0821 22.8775 13.8584 21.2415 12.9691L20.5251 14.2869ZM17.085 13.438C17.469 13.0562 18.0871 12.9616 18.6146 13.2483L19.331 11.9305C18.2474 11.3414 16.9026 11.5041 16.0273 12.3743L17.085 13.438Z" fill="#009CDE"></path> </g></svg>
              <span class="callForAvail"><a href="/pages/contact" style="color:inherit;" target="blank">Call for availability</a></span>`;
    }

    // Conditional Add-to-Cart Button
    let addToCartButtonHTML = '';
    if(variant.inventory_management){
      addToCartButtonHTML = variant.inventory_quantity > 0
        ? `<button onclick="addToCart(${variant.id},event)">ADD TO BASKET</button>`
        : variant.inventory_policy === "deny"
        ? `<button>OUT OF STOCK</button>`
        : `<button class="preOrderBtn" onclick="addToCart(${variant.id},event)">PRE-ORDER</button>`;
    }else{
      addToCartButtonHTML = `<button onclick="addToCart(${variant.id},event)">ADD TO BASKET</button>`
    }

    const productHTML = `
           <div class="appProduct">
               <div class="productCardBadgeBox">
                 ${
                   productPosition
                     ? `<p class='positionBadge'>${productPosition}</p>`
                     : ""
                 }
                 ${
                   productRange
                     ? `<p class='rangeBadge'>${productRange}</p>`
                     : ""
                 }
               </div>
               <div class="product-sku-img-row">
                   <div class="productImgWrapper">
                     <a href='/products/${product.handle}' target="blank">
                       <img
                           src="${product.image_src}"
                           style="width:100%"
                           class="pFirstImage"
                       >
                       ${
                         product.images[1]
                           ? `<img src="${product.images[1].src}" style="width:100%" class="pSecondImage">`
                           : ""
                       }
                   </div>
                   <a href='/products/${
                     product.handle
                   }' target="blank"><p class="partNo">Part No   <strong>${
      variant.sku
    }</strong></p></a>
                   <a href='/products/${
                     product.handle
                   }' target="blank"><p class="partNo"><p class="productTitle">${
      product.title
    }</p></a>
                   <p class="productPrice">
                       <span class="defaultPrice">£${variant.price}</span>
                       <span class="comparePrice">${
                         variant.compare_at_price > 0
                           ? `£${variant.compare_at_price}`
                           : ""
                       }</span>
                       <span class="youSave">
                           ${
                             Number(variant.compare_at_price) > Number(variant.price)
                               ? `You Save: £${(
                                   variant.compare_at_price - variant.price
                                 ).toFixed(2)}`
                               : ""
                           }
                       </span>
                   </p>
                   <div class="stockInfo">
                       ${stockInfoHTML}
                   </div>
                   <p class="productDetailsHeader">More details</p>
                   <div class="productDetails">
                       <p><span>Manufacturer</span><span>${query.manufacturer.toUpperCase()}</span></p>
                       <p><span>Years</span><span>${query.year[0]} - ${
      query.year[query.year.length - 1]
    }</span></p>
                       <p><span>Model</span><span>${query.model.toUpperCase()}</span></p>
                       <p><span>Sub Model</span><span>${
                         query.subModel
                       }</span></p>
                       <p><span>Engine</span><span>${capitalizeWords(
                         query.engine
                       )}</span></p>
                       <p><span>Body</span><span>${query.body}</span></p>
                       ${
                         query.bhp
                           ? `<p><span>BHP</span><span>${query.bhp}</span></p>`
                           : ""
                       }
                       ${
                         query.suspension_A
                           ? `<p><span>Suspension A</span><span>${query.suspension_A}</span></p>`
                           : ""
                       }
                       ${
                         query.transmissionType_A
                           ? `<p><span>Transmission Type A</span><span>${query.transmissionType_A}</span></p>`
                           : ""
                       }
                       ${
                         query.type_A
                           ? `<p><span>Type A</span><span>${query.type_A}</span></p>`
                           : ""
                       }
                       ${
                         query.vehicleEquipment_A
                           ? `<p><span>Vehicle Equipment A</span><span>${query.vehicleEquipment_A}</span></p>`
                           : ""
                       }
                       ${
                         query.chassisNumberFrom_A
                           ? `<p><span>Chassis Number From A</span><span>${query.chassisNumberFrom_A}</span></p>`
                           : ""
                       }
                       ${
                         query.engineCode
                           ? `<p><span>Engine Code</span><span>${query.engineCode}</span></p>`
                           : ""
                       }
                   </div>
               </div>
               
               <div class="addToCardWrapper">
                   <select id="quantitySelect_${variant.id}" >
                       ${quantityDropdownValues
                         .map(
                           (element) =>
                             `<option value="${element}">${element}</option>`
                         )
                         .join("")}
                   </select>
                   <div style="position:relative;width:100%">
                     ${addToCartButtonHTML}
                     <div class="loading__spinner hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                      </div>
                   </div>
               </div>
           </div>`;

    return productHTML;
  }

  // fetch sku and print product cards and run filter logic
  if (window.location.href.includes(pageUrl)) {
    // Function to fetch SKUs based on the selected engine type
    function fetchSKUs(
      selectedManufacturer,
      selectedYear,
      selectedModel,
      selectedSubModel,
      selectedEngine,
      selectedBody
    ) {
      // Check if a engine type is selected
      if (selectedBody) {
        // manufacturer a request to the backend with the selected engine type value
        fetch(
          `${serverUrl}/api/csv-data-skus?manufacturer=${selectedManufacturer}&year=${selectedYear}&model=${selectedModel}&sub_model=${selectedSubModel}&engine=${selectedEngine}&body=${selectedBody}`
        )
          .then((response) => response.json())
          .then((sku) => {
            let skuArr = [];
            let filterClass = document.querySelector(".customFilter");
            filterClass.classList.remove("data-in");
            filterClass.classList.add("data-in");
            for (let element of sku) {
              skuArr.push(element.sku);
            }
            // console.log("sku array ", skuArr);
            domProducts = [];
            // getting product data
            async function getData(skuArr) {
              try {
                const response = await fetch(
                  `${serverUrl}/api/get-products-by-skus`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      skus: skuArr,
                      manufacturer: selectedManufacturer,
                      year: selectedYear,
                      model: selectedModel,
                      subModel: selectedSubModel,
                      engine: selectedEngine,
                      body: selectedBody,
                    }),
                  }
                );
                const { products, csvDataResults } = await response.json();

                csvDataResults.forEach((element) => {
                  let product = products.filter((product) =>
                    product.variants.some(
                      (variant) => variant.sku === element.partNo
                    )
                  );
                  if (product.length > 0) {
                    domProducts.push({
                      query: element,
                      product: product[0],
                    });
                  }
                });
                console.log("domProducts:", domProducts);
                filterChips.innerHTML = "";
                productInfo.innerHTML = "";
                if (domProducts.length > 0) {
                  const getTagArray = async () => {
                    try {
                      const response = await fetch(
                        `${serverUrl}/api/sorting-tags`,
                        {
                          method: "GET",
                        }
                      );
                      const data = await response.json();
                      const arr = data[0].sortTag.split(",");
                      return arr.map(item => item.trim());
                    } catch (error) {
                      console.log("error in getting sorting tags", error);
                    }
                  };
                  
                  // Get tagPriority as an array of priority tags, all lowercased for robustness
                  const tagPriority = (await getTagArray()).map(tag => tag.toLowerCase());
                  
                  function containsTag(tags, tagName) {
                    // tags: array of comma-separated tag strings
                    // tagName: single tag string, already lowercased from tagPriority
                    return tags.some(tagString => 
                      tagString
                        .split(',')
                        .map(t => t.trim().toLowerCase())
                        .includes(tagName)
                    );
                  }
                  
                  if (tagPriority) {
                    domProducts.sort((a, b) => {
                      // Find the index of the highest-priority tag each product has
                      const aPriority = tagPriority.findIndex(tag =>
                        containsTag(a.product.tags, tag)
                      );
                      const bPriority = tagPriority.findIndex(tag =>
                        containsTag(b.product.tags, tag)
                      );
                  
                      // If a product doesn't contain any of the priority tags, set its index to a large number to sort it last
                      const aIndex = aPriority === -1 ? Number.MAX_SAFE_INTEGER : aPriority;
                      const bIndex = bPriority === -1 ? Number.MAX_SAFE_INTEGER : bPriority;
                  
                      return aIndex - bIndex;
                    });
                  }

                  filterInitialise(domProducts);
                  

                  domProducts.forEach((element) => {
                    productInfo.innerHTML += element.product
                      ? productCard(
                          element.query.partNo,
                          element.product,
                          element.query,
                          productDefinedPositions,
                          productDefinedRanges
                        )
                      : "";
                  });
                  showProducts();
                  moreDetailsAccordian();
                } else {
                  productInfo.classList.add("noProductFound");
                }
              } catch (error) {
                console.error("Error fetching products:", error);
              }
            }
            getData(skuArr);
          })
          .catch((error) => console.error("Error fetching SKUs:", error));
      }
    }

    let showBtn = document.querySelector(".showBrakes");
    showBtn.addEventListener("click", function () {
      fetchSKUs(
        manufacturerSelect.value,
        yearSelect.value,
        modelSelect.value,
        subModelSelect.value,
        engineSelect.value,
        bodySelect.value
      );
    });

    // run the logic when page is refresh with all filter values
    if (manufacturer && year && model && subModel && engine && body) {
      fetchSKUs(manufacturer, year, model, subModel, engine, body);
    }
  }

  // filter logic
  function filterInitialise(domProducts) {
    // Open the accordion by default
    $(".filterOptionContent").eq(3).addClass("open").slideDown(100);
    $(".filterOptionContent").eq(4).addClass("open").slideDown(100);
    $(".filterOptionContent").eq(5).addClass("open").slideDown(100);

    let startEndDateArr = [],
      engineCodeArr = [],
      v8TransmissionGearsArr = [],
      tagArr = [];

    domProducts.forEach((element) => {
      if (element.product) {
        element.query.startEndDate != ""
          ? startEndDateArr.push(...element.query.startEndDate)
          : "";
      }
      if (element.product) {
        element.query.engineCode != ""
          ? engineCodeArr.push(...element.query.engineCode)
          : "";
      }
      if (element.product) {
        element.query.v8_Transmission_Gears != ""
          ? v8TransmissionGearsArr.push(...element.query.v8_Transmission_Gears)
          : "";
      }
      if (element.product) {
        element.product.tags != ""
          ? tagArr.push(...element.product.tags[0].split(", "))
          : "";
      }
    });
    let filterValues = {
      startEndDate: new Set(startEndDateArr),
      engineCode: new Set(engineCodeArr),
      v8TransmissionGears: new Set(v8TransmissionGearsArr),
      tagArr: new Set(tagArr),
    };
    // console.log('filter values', filterValues)

    let startEndDateWrapper = document.querySelector(".start_end_date");
    let engineCodeWrapper = document.querySelector(".engine_code");
    let v8TransmissionGearsWrapper = document.querySelector(
      ".v8_transmission_gears"
    );

    let productTypeWrapper = document.querySelector(".Product_Type");
    let positionWrapper = document.querySelector(".Position");
    let rangeWrapper = document.querySelector(".Range");

    $(".filterOptionContent").html("");

    // create options using csv data
    for (let property in filterValues) {
      switch (property) {
        case "startEndDate":
          filterValues[property].forEach((option) => {
            startEndDateWrapper.innerHTML += `<li><input type='checkbox' value='${option}'>${option}</li>`;
          });
          break;
        case "engineCode":
          filterValues[property].forEach((option) => {
            engineCodeWrapper.innerHTML += `<li><input type='checkbox' value=${option}>${option.trim()}</li>`;
          });
          break;
        case "v8TransmissionGears":
          filterValues[property].forEach((option) => {
            v8TransmissionGearsWrapper.innerHTML += `<li><input type='checkbox' value=${option}>${option.trim()}</li>`;
          });
          break;
      }
    }

    // create options using tags
    for (let item of filterQueryData) {
      if (item.name == "Product Type") {
        item.options.forEach((option) => {
          if (filterValues.tagArr.has(option.subCategory)) {
            productTypeWrapper.innerHTML += `<li class="flex py-2" style="justify-content:space-between;">
                                       <div>
                                         <input type="checkbox" value="${
                                           option.subCategory
                                         }">
                                         ${option.subCategory}
                                       </div>
                                       ${
                                         option.labelImage
                                           ? `<img src="${serverUrl}${option.labelImage}" style="height:20px;">`
                                           : option.labelText &&
                                             option.labelImage == null
                                           ? `<span class="labelBox" style="background-color:${option.labelBg}">${option.labelText}</span>`
                                           : `<span class="labelBox" style="background-color:${option.labelBg}"></span>`
                                       }
                                    </li>`;
          }
        });
      } else if (item.name == "Position") {
        productDefinedPositions = [];
        item.options.forEach((option) => {
          productDefinedPositions.push(option.subCategory);
          if (filterValues.tagArr.has(option.subCategory)) {
            positionWrapper.innerHTML += `<li class="flex py-2" style="justify-content:space-between;">
                                       <div>
                                         <input type="checkbox" value="${
                                           option.subCategory
                                         }">
                                         ${option.subCategory}
                                       </div>
                                       ${
                                         option.labelImage
                                           ? `<img src="${serverUrl}${option.labelImage}" style="height:20px;">`
                                           : option.labelText &&
                                             option.labelImage == null
                                           ? `<span class="labelBox" style="background-color:${option.labelBg}">${option.labelText}</span>`
                                           : `<span class="labelBox" style="background-color:${option.labelBg}"></span>`
                                       }
                                    </li>`;
          }
        });
      } else if (item.name == "Range") {
        productDefinedRanges = [];
        item.options.forEach((option) => {
          productDefinedRanges.push(option.subCategory);
          if (filterValues.tagArr.has(option.subCategory)) {
            rangeWrapper.innerHTML += `<li class="flex py-2" style="justify-content:space-between;">
                                       <div>
                                         <input type="checkbox" value="${
                                           option.subCategory
                                         }">
                                         ${option.subCategory}
                                       </div>
                                       ${
                                         option.labelImage
                                           ? `<img src="${serverUrl}${option.labelImage}" style="height:20px;">`
                                           : option.labelText &&
                                             option.labelImage == null
                                           ? `<span class="labelBox" style="background-color:${option.labelBg}">${option.labelText}</span>`
                                           : `<span class="labelBox" style="background-color:${option.labelBg}"></span>`
                                       }
                                    </li>`;
          }
        });
      }
    }

    // applying conditions according to filter selection
    let startEndDateCondition = [];
    let engineCodeCondition = [];
    let v8TransmissionGearsCondition = [];

    let productTypeCondition = [];
    let positionCondition = [];
    let rangeCondition = [];

    const allFilterInputs = document.querySelectorAll(
      ".filterOptionContent input"
    );

    function updateFilterConditions(array, value, add) {
      if (add) {
        if (!array.includes(value)) {
          array.push(value);
        }
      } else {
        // Remove the value using filter to avoid using pop incorrectly
        array = array.filter((item) => item !== value);
      }
      return array; // Return the updated array
    }

    // filter checkbox onclick function
    allFilterInputs.forEach((inputBox) => {
      inputBox.addEventListener("change", function (event) {
        if (
          this.parentElement.parentElement.classList.contains("start_end_date")
        ) {
          startEndDateCondition = updateFilterConditions(
            startEndDateCondition,
            event.target.value,
            event.target.checked
          );
        } else if (
          this.parentElement.parentElement.classList.contains("engine_code")
        ) {
          engineCodeCondition = updateFilterConditions(
            engineCodeCondition,
            event.target.value,
            event.target.checked
          );
        } else if (
          this.parentElement.parentElement.classList.contains(
            "v8_transmission_gears"
          )
        ) {
          v8TransmissionGearsCondition = updateFilterConditions(
            v8TransmissionGearsCondition,
            event.target.value,
            event.target.checked
          );
        } else if (
          this.parentElement.parentElement.parentElement.classList.contains(
            "Product_Type"
          )
        ) {
          productTypeCondition = updateFilterConditions(
            productTypeCondition,
            event.target.value,
            event.target.checked
          );
        } else if (
          this.parentElement.parentElement.parentElement.classList.contains(
            "Position"
          )
        ) {
          positionCondition = updateFilterConditions(
            positionCondition,
            event.target.value,
            event.target.checked
          );
        } else if (
          this.parentElement.parentElement.parentElement.classList.contains(
            "Range"
          )
        ) {
          rangeCondition = updateFilterConditions(
            rangeCondition,
            event.target.value,
            event.target.checked
          );
        }

        let filteredResults = domProducts.filter((product) => {
          const productValues = Object.values(product.query); // Assuming your structure
          const tags =
            product &&
            product.product &&
            typeof product.product.tags !== "undefined"
              ? product.product.tags[0].split(", ")
              : "";

          function flattenArray(data) {
            return data.reduce(
              (acc, val) =>
                Array.isArray(val)
                  ? acc.concat(flattenArray(val))
                  : acc.concat(val.toString()),
              []
            );
          }
          const flattenedArr = flattenArray(productValues);

          // Check conditions with AND between groups, OR within each group
          const meetsCondition1 =
            startEndDateCondition.length === 0 ||
            startEndDateCondition.some((s) =>
              flattenedArr.some((item) => item.includes(s))
            );
          const meetsCondition2 =
            engineCodeCondition.length === 0 ||
            engineCodeCondition.some((s) =>
              flattenedArr.some((item) => item.includes(s))
            );
          const meetsCondition3 =
            v8TransmissionGearsCondition.length === 0 ||
            v8TransmissionGearsCondition.some((s) =>
              flattenedArr.some((item) => item.includes(s))
            );

          const meetsCondition4 =
            productTypeCondition.length === 0 ||
            productTypeCondition.some((condition) => tags.includes(condition));
          const meetsCondition5 =
            positionCondition.length === 0 ||
            positionCondition.some((condition) => tags.includes(condition));
          const meetsCondition6 =
            rangeCondition.length === 0 ||
            rangeCondition.some((condition) => tags.includes(condition));

          return (
            meetsCondition1 &&
            meetsCondition2 &&
            meetsCondition3 &&
            meetsCondition4 &&
            meetsCondition5 &&
            meetsCondition6
          );
        });

        // console.log(filteredResults);

        let c =
          startEndDateCondition.length +
          engineCodeCondition.length +
          v8TransmissionGearsCondition.length +
          productTypeCondition.length +
          positionCondition.length +
          rangeCondition.length;

        if (filteredResults.length > 0) {
          productInfo.innerHTML = "";
          productInfo.classList.remove("noProductFound");
          filteredResults.forEach((element) => {
            productInfo.innerHTML += element.product
              ? productCard(
                  element.query.partNo,
                  element.product,
                  element.query,
                  productDefinedPositions,
                  productDefinedRanges
                )
              : "";
          });
          currentPage = 1;
          showProducts();
        } else if (filteredResults.length == 0 && c != 0) {
          productInfo.innerHTML = "";
          productInfo.classList.add("noProductFound");
          currentPage = 1;
          showProducts();
        } else {
          productInfo.innerHTML = "";
          productInfo.classList.remove("noProductFound");
          domProducts.forEach((element) => {
            productInfo.innerHTML += element.product
              ? productCard(
                  element.query.sku,
                  element.product,
                  element.query,
                  productDefinedPositions,
                  productDefinedRanges
                )
              : "";
          });
          currentPage = 1;
          showProducts();
        }
        $(".customFilter").removeClass("open");
      });
    });
  }

  // fetch tag filter headers and content wrapper from app
  const fetchfilter = async (afterSearch) => {
    const filter = document.querySelector(".tagFilterWrapper");
    if (filter) {
      filter.innerHTML = "";
      let str = "";

      fetch(`${serverUrl}/api/get-category`)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          filterQueryData = data;
          // let specificTag = filterQueryData.filter(item => item.name == 'Compound');
          // tagColors = specificTag[0].options; t
          // console.log('filterQueryData',filterQueryData)
          filterQueryData.forEach((element) => {
            if (afterSearch) {
              str += `<div class="filterSelect">
                               <p class="filterOptionHeader">${element.name}</p>
                               <ul class="filterOptionContent ${element.name.replace(
                                 " ",
                                 "_"
                               )}">
                                 ${element.options
                                   .map(
                                     (option) =>
                                       `<li class="flex py-2" style="justify-content:space-between;">
                                       <div>
                                         <input type="checkbox" value="${
                                           option.subCategory
                                         }">
                                         ${option.subCategory}
                                       </div>
                                       ${
                                         option.labelImage
                                           ? `<img src="${serverUrl}${option.labelImage}" style="height:20px;">`
                                           : option.labelText &&
                                             option.labelImage == null
                                           ? `<span class="labelBox" style="background-color:${option.labelBg}">${option.labelText}</span>`
                                           : `<span class="labelBox" style="background-color:${option.labelBg}"></span>`
                                       }
                                    </li>`
                                   )
                                   .join("")}
                               </ul>
                           </div>`;
            } else {
              str += `<div class="filterSelect">
                               <p class="filterOptionHeader">${element.name}</p>
                               <ul class="filterOptionContent ${element.name.replace(
                                 " ",
                                 "_"
                               )}"></ul>
                           </div>`;
            }
          });
          filter.innerHTML += str;
          filterAccordian();
        })
        .catch((error) => {
          console.error("Failed to fetch categories:", error);
        });
    }
  };
  fetchfilter();
});

// filter accordian
function filterAccordian() {
  // Toggle accordion on header click
  $(".filterOptionHeader").click(function () {
    var content = $(this).next(".filterOptionContent");

    // If the clicked section is already open, close it
    if (content.hasClass("open")) {
      content.removeClass("open").slideUp(100);
    } else {
      // Close all open sections
      // $('.filterOptionContent').removeClass('open').slideUp();

      // Open the clicked section
      content.addClass("open").slideDown(100);
    }
  });
}

if ($(window).width() < 900) {
  $(".mainFilterHeader").click(function () {
    const content = $(this).next(".productSearchWrapper");
    if (content.hasClass("open")) {
      content.removeClass("open").slideUp(100);
    } else {
      content.addClass("open").slideDown(100);
    }
  });

  $(".otherFilters").click(function () {
    const content = $(".customFilter");
    if (content.hasClass("open")) {
      content.removeClass("open");
    } else {
      content.addClass("open");
    }
  });

  $(".customFilter > h5").click(function () {
    $(".customFilter").removeClass("open");
  });
}

function moreDetailsAccordian() {
  if ($(window).width() < 900) {
    $(".productDetailsHeader").click(function () {
      const content = $(this).next(".productDetails");
      if (content.hasClass("open")) {
        content.removeClass("open").slideUp(100);
      } else {
        content.addClass("open").slideDown(100);
      }
    });
  }
}

document.addEventListener("change", function (event) {
  // Check if the changed element is one of our quantity selects
  // if (event.target && event.target.matches('select[id^="quantitySelect_"]')) {
  //     const nextSibling = event.target.closest('.addToCardWrapper').querySelector('button a');
  //     if (nextSibling) {
  //         let newQuantity = event.target.value;
  //         let newHref = nextSibling.href.replace(/quantity=\d+/, `quantity=${newQuantity}`);
  //         nextSibling.href = newHref;
  //     }
  // }
  moreDetailsAccordian();
  let arr = [];
  let c = document.querySelectorAll(".customFilter input");
  let currentFilter = document.querySelector(".currentFilter");

  for (let elem of c) {
    if (elem.checked) {
      arr.push(elem.value);
    }
  }

  if (currentFilter) {
    currentFilter.innerHTML = "";
  }

  arr.forEach((element) => {
    currentFilter.innerHTML += `<div>${element}
                                  <span onClick="removefilter(event)"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
                                   <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                                   <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <rect width="24" height="24" fill="white"/> <path d="M7 17L16.8995 7.10051" stroke="#bfbfbf" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7 7.00001L16.8995 16.8995" stroke="#bfbfbf" stroke-linecap="round" stroke-linejoin="round"/> </g>
                                   </svg>
                                  </span>
                                 </div>`;
  });
});

function removefilter(event) {
  let parentDiv = event.target.closest("div");
  let content = parentDiv.childNodes[0].textContent;
  let customFilterArr = document.querySelectorAll(".customFilter input");
  let result = Array.from(customFilterArr).filter(
    (element) => element.value.trim() == content.trim()
  );
  result.forEach((element) => {
    element.checked = false;
    element.dispatchEvent(new Event("change"));
  });
  parentDiv.remove();
}

// delivery timer
document.addEventListener("DOMContentLoaded", () => {
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return "th"; // Covers 4th - 20th
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  function isHoliday(date) {
    // const holidays = ["2025-03-28"];
    const holidays = ["2025-03-28", "2025-03-31"];
    const dateString =
      date.getFullYear() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    return holidays.includes(dateString);
  }

  function getFixedUKTime() {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    // Format the current date as a string in UK timezone
    const ukDateString = formatter.format(now);

    // Convert the string back to a Date object
    const dateParts = ukDateString.match(
      /(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2}):(\d{2})/
    );
    return new Date(
      `${dateParts[3]}-${dateParts[2]}-${dateParts[1]}T${dateParts[4]}:${dateParts[5]}:${dateParts[6]}`
    );
  }

  function getMonthName(date) {
    return new Intl.DateTimeFormat("en-GB", { month: "short" }).format(date);
  }

  function updateCountdown() {
    var now = getFixedUKTime();
    // var now = new Date('2025-03-27T11:59:00');
    var targetTime = new Date(now.toISOString().split("T")[0]); // Resets to today's date at midnight.
    var deliveryDay; // This will store the date for delivery.

    // Handle specific scenarios for extended hours on weekends
    if (now.getDay() === 4 && now.getHours() >= 12) {
      // thrusday after 12 PM
      // Extend to Monday 12 PM
      targetTime.setDate(now.getDate() + 1);
      targetTime.setHours(10, 30, 0, 0);
      deliveryDay = new Date(targetTime.getTime());
      deliveryDay.setDate(deliveryDay.getDate() + 3);
    } else if (now.getDay() === 5) {
      // Friday after 12 PM
      // Extend to Monday 12 PM
      if (
        now.getHours() < 10 ||
        (now.getHours() == 10 && now.getMinutes() < 30)
      ) {
        targetTime.setDate(now.getDate());
        targetTime.setHours(10, 30, 0, 0);
        deliveryDay = new Date(targetTime.getTime());
        deliveryDay.setDate(deliveryDay.getDate() + 3);
      } else {
        targetTime.setDate(now.getDate() + 3);
        targetTime.setHours(12, 0, 0, 0);
        deliveryDay = new Date(targetTime.getTime());
        deliveryDay.setDate(deliveryDay.getDate() + 1);
      }
    } else if (now.getDay() === 6) {
      // Saturday
      targetTime.setDate(now.getDate() + 2);
      targetTime.setHours(12, 0, 0, 0);
      deliveryDay = new Date(targetTime.getTime());
      deliveryDay.setDate(deliveryDay.getDate() + 1);
    } else if (now.getDay() === 0) {
      // Saturday
      targetTime.setDate(now.getDate() + 1);
      targetTime.setHours(12, 0, 0, 0);
      deliveryDay = new Date(targetTime.getTime());
      deliveryDay.setDate(deliveryDay.getDate() + 1);
    } else {
      if (now.getHours() < 12) {
        // If it's before 12 PM, countdown to today's 12 PM, delivery tomorrow.
        targetTime.setHours(12, 0, 0, 0); // Set target time to today's noon.
        deliveryDay = new Date(targetTime.getTime());
        deliveryDay.setDate(deliveryDay.getDate() + 1); // Delivery tomorrow.
      } else {
        // If it's after 12 PM, countdown to tomorrow's 12 PM, delivery the day after tomorrow.
        targetTime.setDate(targetTime.getDate() + 1); // Move to tomorrow.
        targetTime.setHours(12, 0, 0, 0); // Set target time to noon.
        deliveryDay = new Date(targetTime.getTime());
        deliveryDay.setDate(deliveryDay.getDate() + 1); // Delivery the day after tomorrow.
      }
    }

    // Avoid Sundays and holidays for the delivery day

    while (isHoliday(deliveryDay)) {
      if (deliveryDay.getDay() == 5) {
        if (isHoliday(deliveryDay)) {
          targetTime.setDate(targetTime.getDate() + 1);
          targetTime.setHours(10, 30, 0, 0);
        }
        deliveryDay.setDate(deliveryDay.getDate() + 3);
      } else if (deliveryDay.getDay() == 1) {
        if (isHoliday(deliveryDay)) {
          targetTime.setDate(targetTime.getDate() + 3);
          targetTime.setHours(12, 0, 0, 0);
        }
        deliveryDay.setDate(deliveryDay.getDate() + 1);
      } else {
        if (isHoliday(deliveryDay)) {
          targetTime.setDate(targetTime.getDate() + 1);
        }
        deliveryDay.setDate(deliveryDay.getDate() + 1);
      }
    }

    // Formatting the dispatch date for display
    var dispatchText = document.querySelectorAll(".dispatch-text");
    var dayName = daysOfWeek[deliveryDay.getDay()];
    var dateWithSuffix =
      deliveryDay.getDate() + getOrdinalSuffix(deliveryDay.getDate());
    var monthName = getMonthName(deliveryDay);
    dispatchText.forEach((element) => {
      element.innerHTML = `for delivery ${dayName} ${dateWithSuffix} ${monthName}`;
    });

    // Calculate the time difference and update the countdown
    var timeDifference = targetTime - now;

    if (timeDifference > 0) {
      var hours = Math.floor(timeDifference / 3600000);
      var minutes = Math.floor((timeDifference % 3600000) / 60000);
      var seconds = Math.floor((timeDifference % 60000) / 1000);
      let countdownTimer = document.querySelectorAll(".countdown-timer");
      countdownTimer.forEach((element) => {
        element.innerHTML = `${hours}h ${minutes}m ${seconds}s`;
      });
    } else {
      var hours = Math.floor(timeDifference / 3600000);
      var minutes = Math.floor((timeDifference % 3600000) / 60000);
      var seconds = Math.floor((timeDifference % 60000) / 1000);
      let countdownTimer = document.querySelectorAll(".countdown-timer");
      countdownTimer.forEach((element) => {
        element.innerHTML = `${hours}h ${minutes}m ${seconds}s`;
      });
    }
  }

  setInterval(updateCountdown, 1000);
  updateCountdown(); // Initial call to start the countdown
});

// ebc search page pagination
const productsPerPage = 45;
let currentPage = 1;

function showProducts() {
  const products = document.querySelectorAll("#appProductWrapper .appProduct");
  const totalProducts = products.length;
  const totalPages = Math.ceil(totalProducts / productsPerPage);

  // Calculate the range of products to display
  const start = (currentPage - 1) * productsPerPage;
  const end = start + productsPerPage;
  products.forEach((product, index) => {
    product.style.display = index >= start && index < end ? "block" : "none";
  });

  updatePaginationDisplay(totalPages, totalProducts);
}

function updatePaginationDisplay(totalPages, totalProducts) {
  const paginationLinks = document.getElementById("paginationLinks");
  paginationLinks.innerHTML = ""; // Clear existing links

  // Define the range for the first pages and the last pages
  let startPages = 1;
  let endPages = totalPages;
  let showStartEllipsis = false;
  let showEndEllipsis = false;

  if (totalPages > 6) {
    // More complex pagination scenario
    if (currentPage > 4) {
      showStartEllipsis = true;
      startPages = Math.min(currentPage - 1, totalPages - 5);
    }

    if (currentPage < totalPages - 3) {
      showEndEllipsis = true;
      endPages = Math.max(currentPage + 1, 6);
    }
  }

  // Always show the first three pages
  for (let i = 1; i <= Math.min(3, totalPages); i++) {
    if (i < startPages) {
      paginationLinks.appendChild(createPageLink(i));
    }
  }

  // Show ellipses if necessary before middle pages
  if (showStartEllipsis) {
    paginationLinks.appendChild(createEllipses());
  }

  // Display middle pages if necessary
  for (let i = startPages; i <= endPages; i++) {
    paginationLinks.appendChild(createPageLink(i));
  }

  // Show ellipses if necessary before the last pages
  if (showEndEllipsis) {
    paginationLinks.appendChild(createEllipses());
  }

  // Always show the last three pages
  for (let i = Math.max(totalPages - 2, endPages + 1); i <= totalPages; i++) {
    paginationLinks.appendChild(createPageLink(i));
  }

  document.getElementById("productCount").textContent = `Showing ${Math.min(
    productsPerPage,
    totalProducts - (currentPage - 1) * productsPerPage
  )} of ${totalProducts} products`;
}

function createPageLink(page) {
  const link = document.createElement("button");
  link.textContent = page;
  link.onclick = function () {
    goToPage(page);
  };
  if (page === currentPage) {
    link.classList.add("currentPage");
  }
  return link;
}

function createEllipses() {
  const span = document.createElement("span");
  span.textContent = "...";
  return span;
}

function goToPage(pageNumber) {
  currentPage = pageNumber;
  showProducts();
}

function changePage(step) {
  const totalProducts = document.querySelectorAll(
    "#appProductWrapper .appProduct"
  ).length;
  const totalPages = Math.ceil(totalProducts / productsPerPage);
  currentPage += step;

  // Boundary check for pagination
  if (currentPage < 1) currentPage = 1;
  else if (currentPage > totalPages) currentPage = totalPages;

  showProducts();
}

// Event listeners for pagination buttons
let prevPage = document.getElementById("prevPage");
if (prevPage) {
  prevPage.addEventListener("click", () => changePage(-1));
}
let nextPage = document.getElementById("nextPage");
if (nextPage) {
  nextPage.addEventListener("click", () => changePage(1));
}

//-------- add to cart--------------//
function addToCart(variantId, event) {
  event.target.disabled = true;
  event.target.classList.add("loadingCart");
  event.target.nextElementSibling.classList.remove("hidden");
  let select = document.querySelector(`#quantitySelect_${variantId}`);
  let quantity = select.value;
  fetch(`/cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json(); // This parses the JSON body of the response
    })
    .then((data) => {
      updateCartBubble();
      // popup logic while click on collection page add-to-cart button.
      // updateCartNotification(data.key)

      // drawer logic while click on collection page add-to-cart button.
      updateCartDrawer();

      event.target.disabled = false;
      event.target.classList.remove("loadingCart");
      event.target.nextElementSibling.classList.add("hidden");
    })
    .catch((error) => {
      console.error("Error adding item to cart:", error.message);
    });
}

function updateCartBubble() {
  fetch(`/?section_id=cart-icon-bubble`)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartBubbleContent =
        doc.querySelector(".shopify-section").innerHTML;
      document.querySelector("#cart-icon-bubble").innerHTML =
        newCartBubbleContent;
    })
    .catch((err) => console.error("Failed to update cart bubble:", err));
}

function escapeCSS(id) {
  return id.replace(/([^\w-])/g, "\\$1");
}

function updateCartNotification(addedProductKey) {
  fetch(`/cart?sections=cart-notification-product`)
    .then((response) => response.text())
    .then((text) => {
      const json = JSON.parse(text);
      const html = json["cart-notification-product"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const escapedId = escapeCSS(
        `cart-notification-product-${addedProductKey}`
      );
      const newCartContent = doc.querySelector(`#${escapedId}`);
      if (newCartContent) {
        document.querySelector("#cart-notification-product").innerHTML =
          newCartContent.innerHTML;
        showCartNotification();
      }
    })
    .catch((error) =>
      console.error("Error updating cart notification product:", error)
    );

  fetch(`/cart?sections=cart-notification-button`)
    .then((response) => response.text())
    .then((text) => {
      const json = JSON.parse(text);
      const html = json["cart-notification-button"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartContent = doc.querySelector(`.shopify-section`);
      if (newCartContent) {
        document.querySelector("#cart-notification-button").innerHTML =
          newCartContent.innerHTML;
      }
    })
    .catch((error) =>
      console.error("Error updating cart notification button:", error)
    );
}

function showCartNotification() {
  const notification = document.querySelector("cart-notification");
  if (notification) {
    notification.open();
  }
}

const updateCartDrawer = async () => {
  await updateDrawer();
  openDrawer();
};

const updateDrawer = async () => {
  fetch(`/cart?sections=cart-drawer`)
    .then((response) => response.text())
    .then((text) => {
      const json = JSON.parse(text);
      const html = json["cart-drawer"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartDrawerContent = doc.querySelector("cart-drawer").innerHTML;
      document.querySelector("cart-drawer").innerHTML = newCartDrawerContent;
      document.querySelector("cart-drawer").classList.remove("is-empty");
    })
    .catch((err) => console.error("Failed to update cart drawer:", err));
};

const openDrawer = () => {
  const drawer = document.querySelector("cart-drawer");
  drawer && drawer.open();
};
